import { render } from "./PopularCollections.vue?vue&type=template&id=1bf0a680&scoped=true&ts=true"
import script from "./PopularCollections.vue?vue&type=script&lang=ts"
export * from "./PopularCollections.vue?vue&type=script&lang=ts"

import "./PopularCollections.vue?vue&type=style&index=0&id=1bf0a680&lang=scss&scoped=true"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf0a680"],['__file',"resources/ts/frontend/components/PopularCollections.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bf0a680"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bf0a680', __exports__)) {
    console.log('reload')
    api.reload('1bf0a680', __exports__)
  }
  
  module.hot.accept("./PopularCollections.vue?vue&type=template&id=1bf0a680&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('1bf0a680', render)
  })

}


export default __exports__